<template>
  <generic-modal
    v-if="isWelcomeLogin"
    :height="loginModal.height"
    :width="loginModal.width"
    :paddingTop="loginModal.paddingTop"
    :modalClass="[
      checkIsPWACartDestination()
        ? 'full-screen-popup lg-screen-centered my-address-modal-container cart-my-login'
        : 'full-screen-popup lg-screen-centered my-address-modal-container',
    ]"
    :contentScroll="false"
    :dependentComputedProps="{
      isWelcomeLogin,
    }"
    :background="[checkIsPWACartDestination() ? 'transparent' : '']"
    :backgroundBody="[checkIsPWACartDestination() ? 'white' : '']"
    :animationStyle="[
      checkIsPWACartDestination() ? 'slide-up-stick-bottom' : '',
    ]"
    @close="closeWelcomeLoginModal($event, '')"
  >
    <template v-slot:header>
      <div v-if="showOnlySkip" class="skip-fix mb15">
        <skip-login text-color="color-grey" parent-page="number input" />
      </div>
      <login-carousel
        :landingOtp="true"
        :moduleProps="moduleProps"
        :show-carousel-img="showCarouselImg"
        :show-only-skip="showOnlySkip"
        @click="fireDeadClick()"
        v-if="!checkIsPWACartDestination() && !showOnlySkip"
      />
      <div v-else-if="checkIsPWACartDestination()">
        <img
          :src="staticImgBaseUrl + '/images/global/handle-bg.svg'"
          class="handle-bg"
        />
      </div>
    </template>
    <template v-slot:body>
      <div class="mobile-input-container" id="mobile-input-container">
        <div class="plr16 fs-14 pt24 bold">
          {{ loginProps?.subHeadingText }}
        </div>
        <div
          class="mobile-number-container"
          :class="{ 'border-red': loginError, filled: mobileNo }"
        >
          <div class="country-code">+91</div>
          <input
            class="mobile-number-input"
            id="mobileNumberInput"
            ref="mobileNumberInput"
            type="text"
            name="mobileNoInput"
            placeholder="Enter your mobile no."
            inputmode="numeric"
            maxlength="10"
            autocomplete
            v-model="mobileNo"
            @focus="doViewPortChanges"
            @blur="removeViewPortChanges"
            @keyup.enter="handleEnterKeyPress"
            @input="
              (event) => (mobileNo = event.target.value.replace(/[^\d]+/g, ''))
            "
          />
        </div>
        <div class="sending-otp-message" v-if="showSendingOtp && !loginError">
          {{ loginProps?.sendingOtpText }}
          <div class="loading-sm"></div>
        </div>
        <div class="validation-message color-error" v-else-if="loginError">
          {{ loginError }}
        </div>
        <div
          class="validation-message"
          v-else-if="!showSendingOtp && !disableSendOtp"
        >
          {{ loginProps?.infoTextBelowNumberInput2 }}
        </div>
        <div class="validation-message" v-else-if="!loginError">
          {{ loginProps?.infoTextBelowNumberInput }}
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div
        class="footer-login plr16"
        :class="{ pb16: clientPlatform == 'Web' }"
      >
        <div class="terms-label">
          {{ loginProps?.tncStartText }}
          <span class="tnc fw-700" @click="handleTnCCTA($event)">{{
            loginProps?.tncEndText
          }}</span>
        </div>
        <button
          class="send-otp-button bold hand"
          :disabled="disableSendOtp || disableOtp"
          @click="handleSendOtp($event)"
        >
          <span :class="{ 'color-white': disableSendOtp || disableOtp }">{{
            loginProps?.sendOtpButtonText
          }}</span>
        </button>
      </div>
    </template>
  </generic-modal>
</template>

<script>
import GenericModal from "./GenericModal.vue";
import { LoginStates } from "../helpers/loginStateConstants";
import { staticImgBaseUrl, clientPlatform } from "../config/apiEndpoints";
import fingerPrintInstance from "../store/storeInitializer/initialiseFingerprint";
import { collectData } from "../helpers/fingerPrintHelper";
import { keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { LoginStateStatus } from "../helpers/loginStateConstants";
import Utility from "../helpers/utility";
import {
  EVENT_CLICK_SENDOTP,
  EVENT_LOGIN_DEAD_CLICK,
  EVENT_TYPE_MOBILENUMBER,
} from "../helpers/analyticsEvents";
import { initializeMetaTime } from "../helpers/metaEvents";
import { initializeMoEngageTime } from "../helpers/moengageEvents";
import LoginCarousel from "./LoginCarousel.vue";

import {
  loadAmplitudeUnsentEvents,
  EVENT_PAGEVIEW_LOGINPAGE,
} from "../helpers/analyticsEvents";
import SkipLogin from "./SkipLogin.vue";

const mediaHeightIsSmaller = window.matchMedia("(max-height: 1000px)").matches;

export default {
  name: "WelcomeLogin",
  components: {
    GenericModal,
    LoginCarousel,
    SkipLogin,
  },
  props: ["moduleProps", "propsData"],
  data() {
    return {
      loginModal: {
        width: "100%",
        paddingTop: "0px",
      },
      modulePropsData: {},
      clientPlatform,
      staticImgBaseUrl: staticImgBaseUrl,
      mobileNo: LocalStorageFunc.getUserMobileNo() || "",
      mobileNumberEnterEventProcessed: false,
      disableOtp: false,
      showCarouselImg: true,
      showOnlySkip: false,
      LoginStateStatus,
    };
  },
  async mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : this.propsData || {};

    loadAmplitudeUnsentEvents();

    if (!this.checkIsPWACartDestination()) {
      const { getFPInstance } = fingerPrintInstance;
      collectData({ detector: getFPInstance() }).then((response) => {
        const payload = {
          detectorData: response,
        };
        this.$store.dispatch(keyMapsAction.SEND_FINGER_PRINT, payload);
      });

      if (!LocalStorageFunc.accessToken()) {
        this.$store.dispatch(keyMapsAction.ANONYMOUS_USER_API, {});
      } else {
        this.$store.commit(
          keyMapsMutation.UPDATE_CURRENT_LOGIN_STATE,
          LoginStates.welcomeLogin,
        );
      }
    }
    this.mobileNo = LocalStorageFunc.getUserMobileNo() || "";

    if (
      (this.$store.state.Auth.currentLoginState === LoginStates.welcomeLogin &&
        this.checkIsCartDestination()) ||
      this.loginError
    ) {
      const { getFPInstance } = fingerPrintInstance;
      collectData({ detector: getFPInstance() }).then((response) => {
        const payload = {
          detectorData: response,
        };
        this.$store.dispatch(keyMapsAction.SEND_FINGER_PRINT, payload);
      });
      this.disableOtp = false;
      // this.$store.commit(keyMapsMutation.UPDATE_LOGIN_ERROR, "");
    }

    setTimeout(() => {
      initializeMoEngageTime();
      initializeMetaTime();
    }, 5000);

    Utility.osBackButtonFunc();

    this.$nextTick(() => {
      this.$refs.mobileNumberInput?.focus();
    });
    if (Utility.isCurrentlyAtUrl("/login")) {
      EVENT_PAGEVIEW_LOGINPAGE();
    }
  },
  watch: {
    mobileNo(newVal, oldVal) {
      if (
        (oldVal.length === 10 && newVal.length === 9) ||
        newVal.length === 10
      ) {
        this.isFirstTimeLogin ? this.handleSendOtp() : "";
        this.disableOtp = false;
      } else if (newVal.length !== 10) {
        this.disableOtp = true;
      }
      if (newVal !== oldVal && this.loginError) {
        this.$store.commit(keyMapsMutation.UPDATE_LOGIN_ERROR, "");
      }
    },
    loginError(newVal, oldVal) {
      if (newVal != "" && oldVal !== newVal) {
        const { getFPInstance } = fingerPrintInstance;
        collectData({ detector: getFPInstance() }).then((response) => {
          const payload = {
            detectorData: response,
          };
          this.$store.dispatch(keyMapsAction.SEND_FINGER_PRINT, payload);
        });
        this.disableOtp = true;
      }
    },
  },
  methods: {
    handleSendOtp(e) {
      // this.$store.commit(
      //   keyMapsMutation.UPDATE_CURRENT_LOGIN_STATE,
      //   LoginStates.otpVerification
      // );
      if (this.loginError) {
        this.$store.commit(keyMapsMutation.UPDATE_LOGIN_ERROR, "");
      }
      this.$store.commit(keyMapsMutation.UPDATE_LOCAL_STORAGE_USER_DATA, {
        mobile: this.mobileNo,
      });
      EVENT_CLICK_SENDOTP({ loginMethod: "manual" });
      this.$store.dispatch(keyMapsAction.FORGOT_PASSWORD_API, {
        mobile: this.mobileNo,
        hash: this.hashKey?.key,
        id: this.hashKey?.id,
      });
    },
    handleEnterKeyPress(e) {
      if (!this.disableSendOtp && !this.disableOtp) {
        this.handleSendOtp(e);
      }
    },
    handleTnCCTA(e) {
      Utility.sendToTnC();
    },
    closeWelcomeLoginModal(e) {
      e.stopPropagation();
      document.body.classList.remove("body-stop-scroll-mobile");
      this.$store.commit(
        keyMapsMutation.UPDATE_CURRENT_LOGIN_STATE,
        LoginStates.onboarding,
      );
      this.$store.commit(keyMapsMutation.UPDATE_LOGIN_ERROR, "");
    },
    checkIsCartDestination() {
      return Utility.isCurrentlyAtUrl("/cart");
    },
    checkIsPWACartDestination() {
      return this.checkIsCartDestination() && this.clientPlatform !== "Web";
    },
    doViewPortChanges() {
      if (clientPlatform !== "Web") {
        document.body.classList.add("keyboard-in-view");
        if (mediaHeightIsSmaller) {
          this.showCarouselImg = false;
        }
        this.showOnlySkipBasedOnSmallScreenSize();
      }
    },
    removeViewPortChanges() {
      document.body.classList.remove("keyboard-in-view");
      this.showCarouselImg = true;
      this.showOnlySkip = false;
    },
    showOnlySkipBasedOnSmallScreenSize() {
      if (window.document.getElementsByClassName("modal-header")[0]) {
        let computedStyles = window.getComputedStyle(
          window.document.getElementsByClassName("modal-header")[0],
        );
        let calculatedParentHeight = parseInt(
          computedStyles.height.replace("px", ""),
        );

        let requiredHeight =
          parseInt(computedStyles.width.replace("px", "")) * 0.52;
        // console.log(window.getComputedStyle(el));
        this.showOnlySkip = calculatedParentHeight < requiredHeight;
      } else {
        this.showOnlySkip = false;
      }
    },
    fireDeadClick() {
      EVENT_LOGIN_DEAD_CLICK();
    },
  },
  computed: {
    // HOK - 839 fixes, now back button will always be displayed
    // showBackButton() {
    //   return this.mobileNo.length > 0;
    // },
    disableSendOtp() {
      if (
        this.mobileNo?.length > 0 &&
        this.mobileNo?.length != 10 &&
        !this.mobileNumberEnterEventProcessed
      ) {
        this.mobileNumberEnterEventProcessed = true;
        EVENT_TYPE_MOBILENUMBER({ loginMethod: "manual" });
      }
      return (
        this.mobileNo.length != 10 ||
        this.$store.state.Auth.loginStateStatus ==
          this.LoginStateStatus.SENDING_OTP
      );
    },
    showSendingOtp() {
      return (
        this.$store.state.Auth.loginStateStatus ==
        this.LoginStateStatus.SENDING_OTP
      );
    },
    hashKey() {
      return this.$store.state.FingerPrint.hashKey;
    },
    isWelcomeLogin() {
      return (
        this.$store.state.Auth.currentLoginState === LoginStates.welcomeLogin
      );
    },
    loginProps() {
      return Object.keys(this.modulePropsData).length
        ? this.modulePropsData
        : this.$store.state.Auth.loginProps;
    },
    loginError() {
      return this.$store.state.Auth.loginError;
    },
    isFirstTimeLogin() {
      return this.$store.state.Auth.firstTimeLogin;
    },
  },
};
</script>
